
import Vue from 'vue'
import { VTextField } from 'vuetify/lib'
import JcdcProgressLinear from '@/components/jcdc/JcdcProgressLinear.vue'

export default Vue.extend({
  name: 'JcdcTextField',
  components: {
    VTextField,
    JcdcProgressLinear,
  },
  props: {
    color: { type: String, default: 'primary' },
    label: { type: String, required: true },
    dense: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    counter: { type: [Number, Boolean], default: undefined },
    minimum: { type: Number, default: undefined },
    type: { type: String, default: 'text' },
    rules: {
      type: Array as () => Array<(v: string) => void>,
      default: (): [] => [],
    },
    defaultValue: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    errorMessage: { type: String, default: undefined },
  },
  data() {
    return {
      textValue: this.defaultValue,
      colorValue: this.color,
    }
  },
  computed: {
    computedRules(): Array<(v: string) => void> {
      const ruleArray: Array<(v: string) => void> = [...this.rules]
      // Required
      if (this.required) {
        ruleArray.push(
          (v: string) =>
            Boolean(v ? v.trim() : v) ||
            (this.errorMessage
              ? this.errorMessage
              : `${this.label} is required.`)
        )
      }
      // Min and max length on text input
      if (this.minimum) {
        ruleArray.push(
          (v: string) =>
            (v ? v.trim() : v || '').length >= this.minimum ||
            `Min ${this.minimum} characters`
        )
      }
      if (this.counter) {
        ruleArray.push(
          (v: string) =>
            (v ? v.trim() : v || '').length <= this.counter ||
            `Max ${this.counter} characters`
        )
      }
      // Types
      if (this.type === 'email') {
        ruleArray.push((v: string) => {
          const pattern =
            /^(?:(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))?$/
          return pattern.test(v || '') || 'Invalid e-mail.'
        })
      }
      if (this.type === 'tel') {
        ruleArray.push((v: string) => {
          const pattern =
            /^(?:\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4}))?$/
          return pattern.test(v || '') || 'Invalid phone number.'
        })
      }
      if (this.type === 'LogNo') {
        ruleArray.push((v: string) => {
          const pattern = /^(?:[0-9]{2}-[0-9]{3})?$/
          return pattern.test(v || '') || 'Invalid Log No. ##-###'
        })
      }
      if (this.type === 'ssn') {
        ruleArray.push((v: string) => {
          const pattern = /^(?:\d{3}-\d{2}-\d{4})?$/
          return (
            pattern.test(v || '') ||
            'Invalid social security number. ###-##-####'
          )
        })
      }
      if (this.type === 'zip') {
        ruleArray.push((v: string) => {
          const pattern = /^(?:[0-9]{5}(?:-[0-9]{4})?)?$/
          return pattern.test(v || '') || 'Invalid zip code. #####-####'
        })
      }
      return ruleArray
    },
  },
  watch: {
    defaultValue() {
      this.textValue = this.defaultValue ? this.defaultValue.trim() : ''
    },
  },
  methods: {
    onFocus() {
      this.readonlyHandler()
    },
    onBlur() {
      if (this.readonly) {
        this.colorValue = this.color
      }
    },
    readonlyHandler() {
      this.readonly
        ? (this.colorValue = 'error')
        : (this.colorValue = this.color)
    },
  },
})
